import React from "react"

import { StudyFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchStudy {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: StudyFilters
    onFilter: (filters: StudyFilters) => void
}

const StudySearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchStudy) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default StudySearch
